const SHOW_MORE_CLASS = "active";
const SHOW_MORE_SECTION_ID = "show-more";
const SHOW_MORE_LINK_ID = "channel-show-more";
const SHOW_LESS_LINK_ID = "channel-show-less";

export class ChannelMobileToggle {
    constructor() {
        if (document.getElementsByClassName(SHOW_MORE_LINK_ID)) {
            let _this = this;
            [].forEach.call(document.getElementsByClassName(SHOW_MORE_LINK_ID), function (element) {
                element.addEventListener('click', (e) => { _this.showMore(e); })
            });
            [].forEach.call(document.getElementsByClassName(SHOW_LESS_LINK_ID), function (element) {
                element.addEventListener('click', (e) => { _this.showLess(e); })
            });
        }
    }

    showMore(e) {
        let showMoreLink = (e.currentTarget as HTMLElement);
        if (showMoreLink.classList.contains(SHOW_MORE_CLASS)) {
            showMoreLink.classList.remove(SHOW_MORE_CLASS);
        }

        let showLessLink = showMoreLink.parentElement.getElementsByClassName(SHOW_LESS_LINK_ID)[0] as HTMLElement;
        if (!showLessLink.classList.contains(SHOW_MORE_CLASS)) {
            showLessLink.classList.add(SHOW_MORE_CLASS);
        }


        let moreSection = showMoreLink.parentElement.nextElementSibling as HTMLElement;
        if (!moreSection.classList.contains(SHOW_MORE_CLASS)) {
            moreSection.classList.add(SHOW_MORE_CLASS);
        }

    }

    showLess(e) {
        let showLessLink = (e.currentTarget as HTMLElement);
        if (showLessLink.classList.contains(SHOW_MORE_CLASS)) {
            showLessLink.classList.remove(SHOW_MORE_CLASS);
        }

        let showMoreLink = showLessLink.parentElement.getElementsByClassName(SHOW_MORE_LINK_ID)[0] as HTMLElement;
        if (!showMoreLink.classList.contains(SHOW_MORE_CLASS)) {
            showMoreLink.classList.add(SHOW_MORE_CLASS);
        }

        let moreSection = showMoreLink.parentElement.nextElementSibling as HTMLElement;
        if (moreSection.classList.contains(SHOW_MORE_CLASS)) {
            moreSection.classList.remove(SHOW_MORE_CLASS);
        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/channel-detail.ts